/*export const TEAK_01 = {
  uid: "teak",
  name: "Teak",
  filename: "Teak.png",
  group: "teak_colors",
  price: 0,
};*/
export const TEAK_02 = {
    uid: "bleached",
    name: "Bleached",
    filename: "Bleached.png",
    group: "teak_colors",
    price: 0,
};
export const TEAK_03 = {
    uid: "scrubbed",
    name: "Scrubbed",
    filename: "Scrubbed.png",
    group: "teak_colors",
    price: 0,
};
export const TEAK_04 = {
    uid: "ash",
    name: "Ash",
    filename: "Ash.png",
    group: "teak_colors",
    price: 0,
};
export const TEAK_05 = {
    uid: "walnut",
    name: "Walnut",
    filename: "Walnut.png",
    group: "teak_colors",
    price: 0,
};
export const TEAK_06 = {
    uid: "weathered",
    name: "Weathered",
    filename: "Weathered.png",
    group: "teak_colors",
    price: 0,
};
export const TEAK_07 = {
    uid: "teak",
    name: "Natural Teak",
    filename: "Teak.png",
    group: "teak_natural",
    price: 0,
};
export const TEAK_ALL = [
    //TEAK_01,
    TEAK_02,
    TEAK_03,
    TEAK_04,
    TEAK_05,
    TEAK_06,
    TEAK_07,
];
